"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.advanced-prompts.disabled': 'La funzione prompt avanzati non è disponibile nel tuo piano attuale.',
};
